import commonConfig from '../../../libs/configs/commonConfig';
import Constants from './constants';

export interface TextKeyOverride {
  oldTextKey: string;
  newTextKey: string;
}

interface Response {
  data?: {
    getTextkeyOverrides?: {
      textkeyOverridesList: TextKeyOverride[];
    };
  };
}

export const fetchTextkeyOverrides = async (
  pid: string,
  requestId: string,
  channelSource?: string,
): Promise<Array<TextKeyOverride>> => {
  const fetched = await fetch(commonConfig.graphqlBaseUrl, {
    method: 'POST',

    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `
        {
          getTextkeyOverrides(
            pid: "${pid}",
            requestId: "${requestId}",
            ${channelSource && channelSource.length > 0 ? `channelSource: "${channelSource}",` : ''}
          ) {
            textkeyOverridesList {
              oldTextKey
              newTextKey
            }
          }
        }
        `,
    }),
  });

  const parsed = (await fetched.json()) as Response;

  return parsed.data?.getTextkeyOverrides?.textkeyOverridesList ?? [];
};

export const overrideTextkeysTransformer = (
  textkeys: Record<string, string>,
  pid: string,
  overrideTextkeys?: Array<TextKeyOverride>,
): Record<string, string> => {
  if (!overrideTextkeys) {
    return textkeys;
  }

  return overrideTextkeys.reduce((tks, override) => {
    return {
      ...tks,
      [`${override.oldTextKey}_${pid}`]:
        tks[`${override.newTextKey}_${pid}`] ??
        tks[`${override.newTextKey}_${Constants.DEFAULT_PID}`] ??
        tks[`${override.oldTextKey}_${pid}`] ??
        tks[`${override.oldTextKey}_${Constants.DEFAULT_PID}`],
    };
  }, textkeys);
};
